import type {FC} from 'react';
import {Item} from '@react-stately/collections';
import type {ItemProps} from '@react-types/shared';

const Chip = Item as FC<Partial<ItemProps<unknown>>>;

export {Chip, Chip as TabItem};
export {ChipGroup, ChipGroup as Tabs, type ChipGroupProps, type ChipProps} from './src';
